import { useThemeColor } from '@/utils/theme'
import dayjs from 'dayjs'
import i18n from '@/locales'

const formatObj: any = {
  '-': 'YYYY-MM-DD HH:mm',
  '/': 'YYYY/MM/DD HH:mm'
}

export const formatLang = (str: string, arr: Array<string>) => {
  return str.replace('$1', arr[0]).replace('$2', arr[1]).replace('$3', arr[2])
}
export const formatLangEle = (str: string, arr: Array<string>) => {
  const themeColor = useThemeColor()
  const temp = str?.replace(/#n/g, '\n') || str
  return temp
    .replace('$1', `<span style='color: red !important'>${arr[0]}</span>`)
    .replace('$2', `<span style='color: red !important'>${arr[1]}</span>`)
    .replace('$3', `<span style='color: red !important'>${arr[2]}</span>`)
}

/**
 * 格式化为分钟; 建议只用来格式化服务端时间
 * @param date
 * @param format
 * @returns {string}
 */
export const dateFormateToMin = (date: string | number, format: string) => {
  if (date) {
    const dateSub = date.toString().substring(0, 16)
    const cnMills = dayjs(dateSub).toDate().getTime()
    return dayjs(cnMills).format(formatObj[format])
  } else {
    return ''
  }
}

export const formatTime = (time: string | Date) => {
  const date = dayjs(time)
  const today = dayjs()
  if (today.format('YYYY-MM-DD') === date.format('YYYY-MM-DD')) {
    return i18n.global.t('pc_lesson_today') + ' ' + date.format('HH:mm')
  }
  if (today.subtract(1, 'day').format('YYYY-MM-DD') === date.format('YYYY-MM-DD')) {
    return i18n.global.t('pc_lesson_yesterday') + ' ' + date.format('HH:mm')
  }
  return date.format('YYYY-MM-DD HH:mm')
}

export const homeworkFormatTime = (sec: number) => {
  const s = Math.max(0, Math.floor(sec))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const ss = s % 60
  const pad = (n: number) => (n < 10 ? '0' + n : '' + n)
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(ss)}` : `${pad(m)}:${pad(ss)}`
}


/**
 * 获取当前的日期和时间
 * @returns {string} 当前日期和时间的字符串表示形式
 * @example getCurrentDateTime() // 返回类似 "2023-04-15 12:30" 的字符串
 * @author @gaolei
 */
export function getCurrentDateTime() {
  const now = new Date();
  const year = now.getFullYear();
  const month = ('0' + (now.getMonth() + 1)).slice(-2); // 月份从 0 开始，所以加 1
  const day = ('0' + now.getDate()).slice(-2);
  const hours = ('0' + now.getHours()).slice(-2);
  const minutes = ('0' + now.getMinutes()).slice(-2);
  const seconds = ('0' + now.getSeconds()).slice(-2);

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * 距截止还剩
 * @param duration 倒计时时间 单位s
 * @returns xx天xx小时xx分
 */
export const convertSeconds = (duration: number) => {
  if (duration > 60) {
    var days = Math.floor(duration / (3600 * 24))
    var hours = Math.floor((duration % (3600 * 24)) / 3600)
    var minutes = Math.floor((duration % 3600) / 60)
    let result = ''
    if (days > 0) {
      result += days + i18n.global.t('day_h5')
    }
    if (hours > 0) {
      result += hours + i18n.global.t('app_class_room_hour')
    }
    if (minutes > 0) {
      result += minutes + i18n.global.t('app_my_training_time_min')
    }
    return result
  } else {
    return 1 + i18n.global.t('app_my_training_time_min')
  }
}